module.exports = __webpack_public_path__ + "static/media/product.48af1480.mp4";